export const MENU_TOGGLE = "MENU_TOGGLE";
export const SEARCH_TOGGLE = "SEARCH_TOGGLE";
export const MODAL_TOGGLE = "MODAL_TOGGLE";
export const LOADING = "LOADING";
export const ACTIVE_DATA = "ACTIVE_DATA";
export const MODAL_LOADER = "MODAL_LOADER";
